import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomerMultiPromptTemplate,
  BackendMutationCreateCustomerMultiPromptTemplateArgs,
} from 'src/types/backend';

import { FRAGMENT_MULTI_PROMPT_TEMPLATE } from './schema';

const MUTATION = gql`
  mutation CreateCustomerMultiPromptTemplate(
    $customerId: ID!
    $workspaceId: ID
    $name: String!
    $description: String!
    $info: String
    $fields: JSON!
    $blocks: JSON!
    $status: String
    $csvId: ID
    $templateType: String
    $primaryKey: String
    $selectedHeaders: [String!]
    $templateOutputType: String
    $exampleContent: String
  ) {
    createCustomerMultiPromptTemplate(
      customerId: $customerId
      workspaceId: $workspaceId
      description: $description
      info: $info
      name: $name
      fields: $fields
      blocks: $blocks
      status: $status
      csvId: $csvId
      templateType: $templateType
      primaryKey: $primaryKey
      selectedHeaders: $selectedHeaders
      templateOutputType: $templateOutputType
      exampleContent: $exampleContent
    ) {
      ...CustomerMultiPromptTemplate
    }
  }
  ${FRAGMENT_MULTI_PROMPT_TEMPLATE}
`;

type Variables = BackendMutationCreateCustomerMultiPromptTemplateArgs;
type Result = BackendCustomerMultiPromptTemplate;

export const createCustomerMultiPromptTemplate = async (variables: Variables) => {
  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });
  return getSingleProp<Result>(response.data);
};
